import { render, staticRenderFns } from "./DateBox.vue?vue&type=template&id=c3271906&scoped=true&"
import script from "./DateBox.vue?vue&type=script&lang=js&"
export * from "./DateBox.vue?vue&type=script&lang=js&"
import style0 from "./DateBox.vue?vue&type=style&index=0&id=c3271906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3271906",
  null
  
)

export default component.exports